import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  AbstractControlOptions,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Data } from '@angular/router';
import { Moment } from 'moment';
import moment from 'moment';
import { Subscription, takeUntil } from 'rxjs';
import {
  MatDatepickerInputEvent, MatDatepickerModule,
} from '@angular/material/datepicker';
import { NgIf } from "@angular/common";
import { MatError, MatFormField, MatFormFieldModule, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { User } from "../../common/models/user";
import { Organization } from "../../common/models/organization";
import { MoreOrEqualThanDate } from "../../common/validators/more-or-equal-than-date.validator";
import { LessOrEqualThanDate } from "../../common/validators/less-or-equal-than-date.validator";
import { UtilsProvider } from "../../common/providers/utils-provider.service";

@Component({
  selector: 'app-stats-range-selector',
  templateUrl: './stats-range-selector.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDatepickerModule,
    NgIf,
    MatFormFieldModule,
    MatSuffix,
    MatInputModule,
    TranslateModule,
    MatLabel,
    MatError,
    FlexLayoutModule,
    FormsModule
  ],
  styleUrls: ['./stats-range-selector.scss']
})
export class StatsRangeSelectorComponent implements OnInit, OnChanges, OnDestroy {

    @Output() public dateFromEvent: EventEmitter<Moment> = new EventEmitter<Moment>();
    @Output() public dateToEvent: EventEmitter<Moment> = new EventEmitter<Moment>();

    @Input() public dateFrom: Moment = moment(new Date());
    @Input() public dateTo: Moment = moment(new Date());

    public form: FormGroup;
    public isSubmitting = false;

    private organization: Organization = {} as Organization;
    private athleteUser: User = {} as User;
    private subscriptions: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private utils: UtilsProvider
    ) {
      this.form = this.fb.group({
        dateFrom: [this.dateFrom, [Validators.required]],
        dateTo: [this.dateTo, [Validators.required]]
      }, {
        validators: [
          LessOrEqualThanDate('dateFrom', 'dateTo'),
          MoreOrEqualThanDate('dateTo', 'dateFrom')]
      } as AbstractControlOptions);
    }

    public ngOnInit(): void {
      this.route.data.pipe(
        takeUntil(this.subscriptions)
      ).subscribe((data: Data) => {
            this.organization = data['organization'];
            this.athleteUser = data['athlete'];
          },
        );
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['dateFrom']) {
            this.form.controls['dateFrom'].setValue(changes['dateFrom'].currentValue.toDate());
        }

        if (changes['dateTo']) {
            this.form.controls['dateTo'].setValue(changes['dateTo'].currentValue.toDate());
        }
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public handleFromDateChange(event: MatDatepickerInputEvent<any>) {
        this.dateFrom = event.value;

        if (this.isFormValid()) {
            this.dateFromEvent.emit(this.dateFrom);
        }
    }

    public handleToDateChange(event: MatDatepickerInputEvent<any>) {
        this.dateTo = event.value;

        if (this.isFormValid()) {
            this.dateToEvent.emit(this.dateTo);
        }
    }

    private isFormValid(): boolean {
        this.isSubmitting = true;

        if (this.form.valid) {
            this.isSubmitting = false;

            return true;
        } else {
            this.utils.validateAllFormFields(this.form);
            this.isSubmitting = false;

            return false;
        }
    }

    get f() {
        return this.form.controls;
    }
}
